import { css } from 'styled-components';
import { mapColorLabelToHex } from '@origin-digital/helper';
var VERTICAL_RHYTHM = '4px';

var appendPx = function appendPx(value) {
  return typeof value === 'number' ? value + 'px' : value;
};

export var backgroundColor = function backgroundColor() {
  return css(["", ";"], function (_ref) {
    var color = _ref.color;
    return "background-color: ".concat(mapColorLabelToHex(color), ";");
  });
};
export function height(value) {
  return css(["height:", ";"], appendPx(value));
}
export function minHeight(value) {
  return css(["min-height:", ";"], appendPx(value));
}
export function maxHeight(value) {
  return css(["max-height:", ";"], appendPx(value));
}
export function width(value) {
  return css(["width:", ";"], appendPx(value));
}
export function minWidth(value) {
  return css(["min-width:", ";"], appendPx(value));
}
export function maxWidth(value) {
  return css(["max-width:", ";"], appendPx(value));
}
export function display(value) {
  return css(["display:", ";"], value);
}
export function direction(value) {
  return css(["flex-direction:", ";"], value);
}
export function alignContent(value) {
  return css(["align-content:", ";"], value);
}
export function alignItems(value) {
  return css(["align-items:", ";"], value);
}
export function alignSelf(value) {
  return css(["align-self:", ";"], value);
}
export var flexGrow = css(["flex:1 1 auto;min-height:0;min-width:0;"]);
export var flexNone = css(["flex:0 0 auto;"]);
export var flexShrink = css(["flex:0 1 auto;min-height:0;min-width:0;"]);
export function position(value) {
  return css(["position:", ";"], value);
}
export function justifyContent(value) {
  return css(["justify-content:", ";"], value);
}
export function marginTop(value) {
  return css(["margin-top:calc(", " * ", ");"], VERTICAL_RHYTHM, value);
}
export function marginRight(value) {
  return css(["margin-right:calc(", " * ", ");"], VERTICAL_RHYTHM, value);
}
export function marginBottom(value) {
  return css(["margin-bottom:calc(", " * ", ");"], VERTICAL_RHYTHM, value);
}
export function marginLeft(value) {
  return css(["margin-left:calc(", " * ", ");"], VERTICAL_RHYTHM, value);
}
export function paddingX(value) {
  return css(["padding-left:calc(", " * ", ");padding-right:calc(", " * ", ");"], VERTICAL_RHYTHM, value, VERTICAL_RHYTHM, value);
}
export function paddingY(value) {
  return css(["padding-bottom:calc(", " * ", ");padding-top:calc(", " * ", ");"], VERTICAL_RHYTHM, value, VERTICAL_RHYTHM, value);
}